import React from "react";
import about from "../../../assets/img/home/gallery-banner-new.jpeg"
import { Helmet } from "react-helmet";
import { Link } from "react-router-dom";
function GalleryBanner() {
    return(
      <>
        <Helmet> <title>Gallery | GreenDart Builders</title> </Helmet>
        <div
            className="page-title"
            style={{ backgroundImage: `url(${about})` }}
          >

            {/* <div className="container position-relative">
              <h1  className="sub-banner-header">Gallery</h1>
              <nav className="breadcrumbs">
                <ol>
                  <li><Link className="text-white" to="/">Home</Link></li>
                  <li className="current">Gallery</li>
                </ol>
              </nav>
            </div> */}
          </div>
      </>
    );
}

export default GalleryBanner;